/**
 * Used to determine if the modifier passed in (after splicing out String
 * values) is a valid numeric.
 *
 * @param subject - The modifier, with spliced out Strings beforehand.
 * @returns - True or false, whether the modifier is a valid numeric.
 */
const isNumeric = (subject: number) => {
  return !Array.isArray(subject) && !isNaN(subject);
};

/**
 * The self-destruct directive is used to automatically remove elements from the
 * DOM after a certain amount of time has elapsed.
 */
export default (element: HTMLElement, { modifiers }, { cleanup }) => {
  let selfDestructDelay = 5000;

  // Validate delay modifier and subsequent delay timer modifier
  if (modifiers.includes("delay")) {
    let delayIndex = modifiers.indexOf("delay");
    let delayTimer = modifiers[delayIndex + 1] || "invalid-delay-timer";

    if (isNumeric(delayTimer.split("ms")[0])) {
      selfDestructDelay = Number(delayTimer.split("ms")[0]);
    }
  }

  // Initiate the self-destruct timeout
  let selfDestructTimeout = setTimeout(
    () => element.remove(),
    selfDestructDelay
  );

  cleanup(() => {
    clearTimeout(selfDestructTimeout);
  });
};
